/*
 * Vignette d'image construite en JavaScript — SOURCE UNIQUE du balisage.
 *
 * Deux endroits du thème fabriquaient une balise `img` à la main dans une chaîne de caractères :
 * `assets/search.js` (vignette des recherches récentes) et `assets/cart-ajax.js` (vignette de
 * la notification « ajouté au panier »). Toutes deux sortaient SANS `width`/`height`, et celle
 * du panier sans largeur dans l'URL non plus — le CDN servait donc l'original pour une boîte
 * de 180 px. Les écrire deux fois, c'était aussi corriger deux fois : d'où ce seul endroit.
 *
 * Ce que la fonction garantit, et qui est éprouvé par `tools/check-vignettes-js.mjs` :
 *   · une balise `img` ne sort JAMAIS sans `width` ET `height` — si la réponse de l'API ne porte
 *     pas de quoi calculer le rapport, on rend une chaîne vide plutôt qu'une balise qui
 *     mentirait sur ses dimensions ou n'en déclarerait aucune ;
 *   · la hauteur est DÉDUITE du rapport réel de l'image, jamais supposée carrée ;
 *   · l'URL porte la largeur demandée, une seule fois ;
 *   · tout ce qui vient de l'API est échappé avant d'entrer dans un attribut (un guillemet
 *     dans un titre de produit refermait l'attribut `alt` et cassait la balise).
 *
 * Chargé par `snippets/theme-scripts.liquid`, en `defer`, AVANT ses deux consommateurs.
 */
(function (fenetre) {
  'use strict';

  /*
   * Largeurs demandées au CDN, en pixels. Règle unique : DEUX FOIS la boîte CSS de la
   * vignette, pour les écrans à forte densité. Les boîtes vivent dans la feuille de style,
   * qui reste la seule source du design ; `tools/check-vignettes-js.mjs` MESURE l'accord
   * entre chaque largeur ci-dessous et la règle CSS correspondante — déplacer la boîte sans
   * déplacer la largeur fait rougir le contrôle.
   */
  fenetre.vignetteLargeurs = {
    // `.recent-search-listing li img` — boîte de 60 px (largeur et hauteur figées en CSS).
    rechercheRecente: 120,
    // `.atc-notification__image img` — boîte de 180 px de large, hauteur libre.
    notificationPanier: 360,
  };

  /** Rend un texte sûr dans un attribut HTML. */
  function echapper(texte) {
    return String(texte === null || texte === undefined ? '' : texte)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /** Rapport largeur/hauteur de l'image, ou 0 si la réponse ne permet pas de le connaître. */
  function rapport(image) {
    var largeur = Number(image.width);
    var hauteur = Number(image.height);
    if (largeur > 0 && hauteur > 0) return largeur / hauteur;
    // `/cart/add.js` porte `aspect_ratio` en plus de `width`/`height` : repli si l'une manque.
    var ratio = Number(image.aspect_ratio);
    return ratio > 0 ? ratio : 0;
  }

  /** Ajoute la largeur demandée à l'URL du CDN, sans jamais en écrire deux. */
  function urlLargeur(url, largeur) {
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + largeur;
  }

  /**
   * Balisage d'une vignette, ou chaîne vide si l'image n'est pas exploitable.
   *
   * @param {{src?: string, url?: string, width?: number, height?: number, aspect_ratio?: number}} image
   *        objet image d'une réponse Shopify : `product.image` (`/products/<handle>.json`)
   *        ou `featured_image` (`/cart/add.js`). Les deux formes sont acceptées.
   * @param {number} largeur  largeur demandée au CDN, prise dans `vignetteLargeurs`.
   * @param {string} alt      texte de remplacement, échappé ici.
   */
  fenetre.vignetteImg = function (image, largeur, alt) {
    if (!image) return '';
    var source = image.src || image.url;
    var ratio = rapport(image);
    if (!source || !(largeur > 0) || !ratio) return '';
    var hauteur = Math.round(largeur / ratio);
    var src = echapper(urlLargeur(source, largeur));
    var texte = echapper(alt);
    return '<img src="' + src + '" width="' + largeur + '" height="' + hauteur + '" alt="' + texte + '" loading="lazy">';
  };
}(window));
